import { patchState, signalStoreFeature, type, withMethods } from '@ngrx/signals';
import { IEmployeeState, initialEmployeeState } from './employee.state';
import { Employee } from '../../models/employee/employee.model';

export const withEmployeeStateMethods = signalStoreFeature(
  { state: type<IEmployeeState>() },
  withMethods((store) => ({
    setEmployees: (employees: Employee[]) => {
      patchState(store, { employees, loading: false, error: null });
    },
    setSelectedEmployee: (employee: Employee | null) => {
      patchState(store, { selectedEmployee: employee, loading: false, error: null });
    },
    addEmployee: (employee: Employee) => {
      patchState(store, { employees: [...store.employees(), employee], loading: false, error: null });
    },
    updateEmployee: (employee: Employee) => {
      patchState(store, {
        employees: store.employees().map((e) => (e.employeeGuid === employee.employeeGuid ? employee : e)),
        selectedEmployee:
          store.selectedEmployee()?.employeeGuid === employee.employeeGuid
            ? employee
            : store.selectedEmployee(),
        loading: false,
        error: null,
      });
    },
    removeEmployee: (employeeGuid: string) => {
      patchState(store, {
        employees: store.employees().filter((e) => e.employeeGuid !== employeeGuid),
        selectedEmployee:
          store.selectedEmployee()?.employeeGuid === employeeGuid ? null : store.selectedEmployee(),
        loading: false,
        error: null,
      });
    },
    setError: (error: string) => {
      patchState(store, { error, loading: false });
    },
    clearEmployees: () => {
      patchState(store, initialEmployeeState);
    },
  }))
);
